module.exports = __webpack_public_path__ + "static/img/Y2D200.8d12e70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Y2D200.png
// module id = dr3h
// module chunks = 2